import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AiInitialDataResolver } from './ai.resolvers';
import { MaintenanceFuseComponent } from '../../../shared/src/lib/feature-fuse/maintenance-fuse/maintenance-fuse.component';
import { mobileDeviceGuard } from '../../../shared/src/lib/guard/mobile-device.guard';

const routes: Routes = [
  //{ path: '**', redirectTo: 'maintenance' },

  { path: '', pathMatch: 'full', redirectTo: 'error' },

  // Auth routes for guests
  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    resolve: {
      initialData: AiInitialDataResolver,
    },
    children: [
      // Page de blocage mobile (cible de redirection du guard)
      { path: 'mobile-blocked', loadComponent: () => import('../../../shared/src/lib/feature-fuse/mobile-blocked/mobile-blocked.component').then(m => m.MobileBlockedComponent) },
      // Routes FlashLevel AI (protégées par le guard mobile)
      { path: 'ai/exam/:token', canActivate: [mobileDeviceGuard], loadChildren:  () => import('./pages/AI/AI-exam/AI-exam-room.module').then(m => m.AIExamRoomModule) },
      { path: 'ai/onboarding/:token', canActivate: [mobileDeviceGuard], loadChildren:  () => import('./pages/AI/AI-exam-onboarding-view/AI-exam-onboarding-view.module').then(m => m.AIExamOnboardingViewModule)},
      { path: 'ai/results/:token', loadChildren:  () => import('./pages/AI/AI-exam-results-view/AI-exam-results-view.module').then(m => m.AIExamResultsViewModule)},
      { path: 'error', loadChildren:  () => import('./pages/AI/AI-exam-error/AI-exam-error.module').then(m => m.AIExamErrorViewModule)},
      { path: 'votre-avis-nous-interesse/:token', loadChildren: () => import('./pages/AI/AI-poll/AI-poll.module').then(m => m.AIPollViewModule) },
      { path: 'maintenance', component: MaintenanceFuseComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
